import { render, staticRenderFns } from "./MeasureAssigned.vue?vue&type=template&id=af4ac5c6"
import script from "./MeasureAssigned.vue?vue&type=script&lang=js"
export * from "./MeasureAssigned.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports